import * as CryptoJS from 'crypto-js';

//The set method is use for encrypt the value.
export const EncryptService = (value) => {
    var key = CryptoJS.enc.Utf8.parse('numbermall2023bm');
    var iv = CryptoJS.enc.Utf8.parse('numbermall2023bm');
     
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
    {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return encrypted.toString();
  };

  //The get method is use for decrypt the value.
 export const DecryptService = (value)=> {
    var key = CryptoJS.enc.Utf8.parse('numbermall2023bm');
    var iv = CryptoJS.enc.Utf8.parse('numbermall2023bm');
    var decrypted = CryptoJS.AES.decrypt(value, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
